import React from 'react';
import { render, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import ErrorLogLookup from './ErrorLogLookup';
import { performSearch } from './utils/searchService';

jest.mock('./utils/searchService');

describe('ErrorLogLookup', () => {
  const defaultProps = {
    csrfToken: 'test-csrf-token',
    searchUrl: '/internal_admin/error_log_lookup/search',
  };

  let pushStateSpy;

  beforeEach(() => {
    performSearch.mockReset();
    pushStateSpy = jest
      .spyOn(window.history, 'pushState')
      .mockImplementation(() => {});
  });

  afterEach(() => {
    pushStateSpy.mockRestore();
    jest.restoreAllMocks();
  });

  const renderPage = (props = {}) =>
    render(<ErrorLogLookup {...defaultProps} {...props} />);

  const submitSearch = (container, getByRole) => {
    const errorIdInput = container.querySelector('input[name="error_id"]');
    userEvent.type(errorIdInput, 'a1b2c3d4-e5f6-7890-abcd-ef1234567890');
    userEvent.click(getByRole('button', { name: 'Search' }));
  };

  it('renders the page title "Error Log Lookup"', () => {
    const { getByText } = renderPage();

    expect(getByText('Error Log Lookup')).toBeInTheDocument();
  });

  it('renders the search form', () => {
    const { getByLabelText, getByRole } = renderPage();

    expect(getByLabelText('Error ID')).toBeInTheDocument();
    expect(getByRole('button', { name: 'Search' })).toBeInTheDocument();
  });

  it('shows loading state during search', async () => {
    performSearch.mockReturnValue(new Promise(() => {}));

    const { container, getByRole, getByText } = renderPage();

    submitSearch(container, getByRole);

    await waitFor(() => {
      expect(
        getByText('Querying log events — this may take 5-15 seconds'),
      ).toBeInTheDocument();
    });
  });

  it('displays results after successful search', async () => {
    const searchResults = {
      events: [
        {
          '@id': 'evt-001',
          '@timestamp': '2026-03-28T14:30:00.000Z',
          Level: 'ERROR',
          message: 'Test error event',
        },
      ],
      anchor_id: 'evt-001',
      error_ids: ['evt-001'],
    };

    performSearch.mockResolvedValue(searchResults);

    const { container, getByRole, getByText } = renderPage();

    submitSearch(container, getByRole);

    await waitFor(() => {
      expect(getByText('1 event found')).toBeInTheDocument();
    });

    expect(getByText('Test error event')).toBeInTheDocument();
  });

  it('shows error alert on search failure', async () => {
    performSearch.mockRejectedValue(new Error('Log query timed out.'));

    const { container, getByRole, getByText } = renderPage();

    submitSearch(container, getByRole);

    await waitFor(() => {
      expect(getByText('Log query timed out.')).toBeInTheDocument();
    });
  });

  it('shows "Copy All" button with results', async () => {
    const searchResults = {
      events: [
        {
          '@id': 'evt-001',
          '@timestamp': '2026-03-28T14:30:00.000Z',
          Level: 'ERROR',
          message: 'Test error event',
        },
      ],
      anchor_id: 'evt-001',
      error_ids: ['evt-001'],
    };

    performSearch.mockResolvedValue(searchResults);

    const { container, getByRole } = renderPage();

    submitSearch(container, getByRole);

    await waitFor(() => {
      expect(getByRole('button', { name: 'Copy All' })).toBeInTheDocument();
    });
  });
});
